import { OrderAhead } from "./interfaces";

export const selectedPickup = (state: OrderAhead) => {
  return state.selectedPickup;
};

export const getActiveVendorId = (state: OrderAhead) => {
  return state.activeVendorId;
};
